/**
 * Created by Mark on 01/12/2016.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';

export default class TableHeader extends React.Component {

    constructor(props){
        super();
        this.state={
            columns : props.columns || [],
            hasActions : true
        }
    }


    getHeaderRows(){

        var rows = [];

        for (var i=0; i < this.state.columns.length; i++) {




            rows.push(<th className={this.state.columns[i].className}><FormattedMessage id={ this.state.columns[i].translationsID.toString() } defaultMessage={ this.state.columns[i].defaultMessage.toString() } /></th>);
        }

        return rows;
    }


    componentWillReceiveProps(props){
        this.setState({
            columns:props.columns
        })
    }

    render(){
        return (

            <thead>
                <tr>
                    { this.getHeaderRows() }
                </tr>
            </thead>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/table.header.component.js